import React from 'react';
import { Stack, Box, Typography, CircularProgress } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface GroupByShowMoreProps {
  row: any;
  handleShowMoreClick: (row: any) => void;
  isLoading?: boolean;
}

const GroupByShowMore: React.FC<GroupByShowMoreProps> = ({
  row,
  handleShowMoreClick,
  isLoading = false,
}) => {
  const handleClick = () => {
    if (!isLoading) {
      handleShowMoreClick(row);
    }
  };

  if (isLoading) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          pl: 6,
          height: 32,
        }}
        onClick={handleClick}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 1.5,
            py: 0.5,
            backgroundColor: '#9E9E9E',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.7rem',
            height: '24px',
            borderRadius: '4px',
            minWidth: '70px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <CircularProgress size={16} sx={{ color: '#fff', mr: 1 }} />
          <Typography
            sx={{
              fontSize: '14px',
              color: '#ffffff',
              fontWeight: 500,
            }}
          >
            Loading...
          </Typography>
        </Box>
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        pl: 6,
        cursor: 'pointer',
        height: 32,
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.03)',
        },
      }}
      onClick={handleClick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1.5,
          py: 0.5,
          backgroundColor: '#9E9E9E',
          color: '#fff',
          fontWeight: 600,
          fontSize: '0.7rem',
          height: '24px',
          borderRadius: '4px',
          minWidth: '70px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <ChevronRightIcon
          sx={{
            fontSize: 18,
            color: '#000000',
            transform: 'rotate(90deg)',
            mr: 0.5,
          }}
        />
        <Typography
          sx={{
            fontSize: '14px',
            color: '#000000',
            fontWeight: 500,
          }}
        >
          Show more
        </Typography>
      </Box>
    </Stack>
  );
};

export default GroupByShowMore;